import { createAction } from '@reduxjs/toolkit';
import {
    TabSyncedChanges
} from '../../../types';
import { ManualModeChangesDiscarded } from '../../sheetsManagerSliceHelpers';

const SHEETS_SYNC_NAMESPACE = 'sheetsManager/sync';

export const syncTabChanges = createAction<TabSyncedChanges>(
  `${SHEETS_SYNC_NAMESPACE}/tabChanges`
);
export const tabSyncManualModeDiscardChanges =
  createAction<ManualModeChangesDiscarded>(
    `${SHEETS_SYNC_NAMESPACE}/discardManualModeTabChanges`
  );
